document.addEventListener('DOMContentLoaded', function() {

  // Sélectionner tous les bundles
  const bundles = document.querySelectorAll('.bundles.product-form-block .bundle');
  const quantityInput = document.getElementById('Quantity');

  // Ajouter un écouteur d'événement à chaque bundle
  if (bundles){
    bundles.forEach(bundle => {
      bundle.addEventListener('click', function() {
        // Vérifier si ce bundle n'est pas déjà actif
        if (!this.classList.contains('active')) {
          // Trouver le bundle actuellement actif et supprimer sa classe
          const activeBundle = document.querySelector('.bundles.product-form-block .bundle.active');
          if (activeBundle) {
            activeBundle.classList.remove('active');
          }
          
          // Ajouter la classe active au bundle cliqué
          this.classList.add('active');
          
          // Obtenir l'attribut quantity
          const quantityAttr = this.getAttribute('quantity');
          
          // Si l'attribut contient un tiret, prendre le premier chiffre
          let newQuantity = quantityAttr;
          if (quantityAttr.includes('-')) {
            newQuantity = quantityAttr.split('-')[0];
          }
          
          // Mettre à jour la valeur dans l'input de quantité
          quantityInput.value = newQuantity;
          
          // Déclencher l'événement change pour activer la fonction changeQtyPrice()
          const event = new Event('change');
          quantityInput.dispatchEvent(event);
        }
      });
    });
  }  

  document.addEventListener('click', function(e) {
    if (e.target.closest('.shopify_subscriptions_app_block input')) {
      const price = e.target.dataset.variantPrice;
      if (price) {
        document.getElementById('price_on_button').innerHTML = price;
      }
    }
  });

  document.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(function(el) {
    el.style.borderBottom = 'solid 1px black';
  });

});